// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BgVF","footer":"styles_footer__18pue","passCodeTooltip":"styles_passCodeTooltip__1SCEo"};